import queryKeys from '@/constants/queryKeys';
import { useAuthContext } from '@/context/auth/useAuthContext';
import { userGet } from '@/services/api/requests/user';
import { useAppStore } from '@/store/useAppStore';
import { useQuery } from '@tanstack/react-query';

const useSyncUserDataToStore = () => {
  const { user, setUser } = useAppStore();
  const { isAuthenticated } = useAuthContext();

  const { isLoading, data, isError, error, isRefetching, refetch, isSuccess } = useQuery({
    queryKey: [queryKeys.user.info, user?.email],
    enabled: isAuthenticated,
    queryFn: async () => {
      const response = await userGet();
      setUser(response);

      return response;
    },
  });

  return { isLoading, data, isError, error, isRefetching, refetch, isSuccess };
};

export { useSyncUserDataToStore as useUser };

export default useSyncUserDataToStore;
